export const COVERAGE_TYPES_FIELD = "_coverage_types";
export const SPLIT_GROUP_FIELD = "_split_group_id";

/**
 * The Objektsparten whose coverage type the definition declares, sorted by
 * name. `objektSparten` is `[{ sparte_id, sparte, coverage_type }]` of the
 * claim's Objekt: `sparte_id` the catalog Sparte, `sparte` its current name.
 */
export function coverageObjektSparten(coverageTypes, objektSparten) {
  const keys = (coverageTypes ?? []).map((type) => type.key);
  return (objektSparten ?? [])
    .filter((sparte) => keys.includes(sparte.coverage_type))
    .sort((a, b) => a.sparte.localeCompare(b.sparte));
}

/** The Objekt's Objektsparten of one coverage type, sorted by name. */
export function objektSpartenOfType(objektSparten, key) {
  return (objektSparten ?? [])
    .filter((sparte) => sparte.coverage_type === key)
    .sort((a, b) => a.sparte.localeCompare(b.sparte));
}

/**
 * The selected Objektsparte of the first coverage type in definition order
 * that has one, or null.
 */
export function firstSelectedObjektSparte(
  coverageTypes,
  objektSparten,
  selectedIds
) {
  for (const type of coverageTypes ?? []) {
    const match = (objektSparten ?? []).find(
      (sparte) =>
        sparte.coverage_type === type.key &&
        (selectedIds ?? []).includes(sparte.sparte_id)
    );
    if (match) return match;
  }
  return null;
}
